module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"selectWallet":"Selecionar carteira"},"en":{"selectWallet":"Select wallet"},"es":{"selectWallet":"Seleccionar cartera"},"fr":{"selectWallet":"Sélectionnez le portefeuille"}}')
  delete Component.options._Ctor
}
